import "components/Flow/Flow.css";

import DiscipleshipPathwayNode from "./DiscipleshipPathwayNode";


export const nodeTypes = {
  discipleshipPathwayNode: DiscipleshipPathwayNode,
};
